import { DialogTransitionContextProps } from './DialogTransitionContextProps'
import { createContext } from 'react'

export const DialogTransitionContext = createContext<DialogTransitionContextProps | undefined>(
  undefined
)
